var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.cstore.getCruiseBook.resolve.roomDetail.svgjpg.is
        ? _c(
            "span",
            [
              _c(
                _setup.ShowHideB,
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "sch" }, [
                              _c("div", { staticClass: "sch-blo" }, [
                                _c("div", { staticClass: "sch-h" }, [
                                  _vm._v(
                                    _vm._s(
                                      _setup.cstore.getCruiseBook.resolve.ship
                                        .name
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  { staticClass: "btn btn--ora sch-b" },
                                  [_vm._v("Смотреть схему")]
                                ),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2119679546
                  ),
                },
                [
                  _vm._v(" "),
                  [
                    _c(_setup.BigScheme, {
                      staticClass: "sch__BigScheme",
                      attrs: {
                        scheme:
                          _setup.cstore.getCruiseBook.resolve.roomDetail.svgjpg,
                        CabinMap: _setup.cstore.getCruiseBook.CabinMap,
                        show: "all",
                      },
                    }),
                  ],
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_setup.PriceTreeFree.length
        ? _c("div", { staticClass: "cabin-type" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_setup.PriceTreeFree, function ({ CabinSet, CabinsFree }) {
        return _c("div", { staticClass: "cabin-type" }, [
          _c(
            "div",
            { staticClass: "cabin-type__slider" },
            [
              _c(_setup.MySlider, {
                attrs: {
                  slides: CabinSet.photos,
                  convertCdn: true,
                  srcKey: "src",
                  idKey: "id",
                  slideRatio: 4 / 6,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cabin-type__info" }, [
            _c("div", { staticClass: "cabin-type__name" }, [
              _vm._v(_vm._s(CabinSet.name)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cabin-type__section" }, [
              _c("div", { staticClass: "cabin-type__section-name" }, [
                _vm._v("Расположение:"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cabin-type__section-value" }, [
                _vm._v(
                  _vm._s(
                    CabinSet.decks.length ? CabinSet.decks[0].name : "—————"
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cabin-type__section cabin-type__section--price" },
              [
                _c("div", { staticClass: "cabin-type__section-name" }, [
                  _vm._v("Стоимость:"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cabin-type__section-value" },
                  [
                    _c(_setup.PriceCurrencyV, {
                      attrs: { price: CabinSet.baseprice },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          CabinsFree.length
            ? _c("div", { staticClass: "cabin-type__free-cabins" }, [
                _c("div", { staticClass: "cabin-type__free-cabins-title" }, [
                  _vm._v(
                    _vm._s(
                      _setup.numWord(CabinsFree.length, [
                        "свободна",
                        "свободных",
                        "свободных",
                      ])
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cabin-type__rooms" },
                  _vm._l(CabinsFree, function (cab) {
                    return _c(_setup.RoomSelector, {
                      key: cab.id,
                      attrs: { Cabin: cab, CabinSet: CabinSet },
                    })
                  }),
                  1
                ),
              ])
            : _c("div", { staticClass: "cabin-type__free-cabins--no-free" }, [
                _vm._v("Нет свободных кают"),
              ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "cabin-type__cat-selector" }, [
      _c("div", { staticClass: "cabin-type__free-cabins--no-free" }, [
        _vm._v("Нет свободных кают"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }